import Block from './Block'
import Modal from '../modal'
import HTML from '../html'
import sharedData from '../shared-data'

export default class VisningList extends Block {
    
    constructor(elementRoot) {
        super(elementRoot)
        
        this.mapButtons = this.root.find('.visning__link.showroom')
        this.showroomLocation = {
            lat: 0,
            lng: 0,
        }
        
        this.mapRoot = HTML('div').classes('map-root rmodal-inner-container').render()
        
        this.showroomModal = new Modal()
        this.showroomModal.defineContent(this.mapRoot)
        
        this.showroomModal.on('show:end', modal => {
            sharedData.googleMap.loadAssetsAsync(() => this._createMap())
        })
        
        this.mapButtons.each((i, b) => {
            let button = $(b)
            let showroomLocation = {
                lat: button.data('showroom-latitude'),
                lng: button.data('showroom-longitude'),
            }
            
            button.on('click', event => {
                event.preventDefault()
                this._clearMap()
                this.showroomLocation = showroomLocation
                this.showroomModal.show()
            })
        })
    }
    
    _clearMap() {
        $(this.mapRoot).empty()
        return this
    }
    
    _createMap() {
        if (!sharedData.googleMap.JSAPIEmbedded) {
            return
        }
        var gmap = new google.maps.Map(this.mapRoot, {
            styles: sharedData.googleMap.style,
            zoom: 12,
            center: this.showroomLocation,
        })
        
        var infoWindow = new google.maps.InfoWindow({
            content: HTML('h4').content('Hello maps!').render(),
        })
        
        var gmarker = new google.maps.Marker({
            position: this.showroomLocation,
            map: gmap,
            animation: google.maps.Animation.DROP,
            icon: sharedData.googleMap.projektIcon,
        })
        
        gmarker.addListener('click', () => {
            infoWindow.open(gmap, gmarker)
        })
    }
}
